// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__19O80","notes":"Notes_notes__F2Zv1"};